<div class="routed-container">
	<div class="routed-content">
		<h2>Additional Links</h2>
		<h3><a href="https://share.hsforms.com/12cDVH6k7QUaM1Ye3gwizVw5cu2n">Time Off Request</a></h3>
		<h3><a href="https://share.hsforms.com/1pdgQyqeKSIu3vr9UQ7sG9A5cu2n">Supply Request</a></h3>
		<h3><a href="https://share.hsforms.com/1qeQDD0fiS7a2QNpzP5Bsbg5cu2n">Training Assessment</a></h3>
		<h3><a href="https://kingtrivia.com/quizmaster-reimbursement-information/">QM Reimbursement Info</a></h3>
		<h3><a [routerLink]="'/workplace-safety'">Workplace Violence Prevention Program</a></h3>
		<h3><a href="https://kingtrivia-8996927.hs-sites.com/knowledge">King Trivia Knowledgebase</a></h3>
	</div>
</div>
